import { render, staticRenderFns } from "./PreferencesSpecTypePage.vue?vue&type=template&id=1e0a26ba"
import script from "./PreferencesSpecTypePage.vue?vue&type=script&lang=js"
export * from "./PreferencesSpecTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports